define('models/calendar/session/renamed-animation',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
], function(_, Backbone, U, API) {

    var MRenamedAnimation = Backbone.Epoxy.Model.extend({
        idAttribute: '_id',
        blacklist: ['group'],

        urlRoot: function() {
            var url = "exercises/renamed/";

            if (this.isNew()) {
                return API.url("groups/" + this.get('group') + "/" + url);
            }

            return API.url(url);
        },
        defaults: function() {
            return {
                exercise: "",
                name: "",
                description: ""
            };
        },

        computeds: {
            exerciseName: {
                deps: ['exercise'],
                get: function(exercise) {
                    return exercise ? exercise.name : "";
                },
            },
        },

        getExercise: function() {
            return this.get('exercise');
        },

        resetWithAnimation: function(animation) {
            return this.reset({ exercise: animation.toJSON() });
        },

        save: function(attrs, options) {
            if (this.isNew()) {
                this.set('exercise', this.get('exercise')._id);
                attrs = _.extend({}, this.attributes);
            }

            MRenamedAnimation.__super__.save.apply(this, [attrs, options]);
        },

    });
    // Return the model for the module
    return MRenamedAnimation;
});

